import statesJson from './states.json';

export type ChildSupportModelType = 'income_shares' | 'percentage_obligor' | 'melson';

type SharedStateConfig = {
  code: string;
  slug: string;
  name: string;
  modelType: ChildSupportModelType;
  stateFactor: number;
  lowIncomeReserve: number;
  officialCalculatorUrl: string;
  requiresLegalReview: boolean;
};

type IncomeSharesConfig = SharedStateConfig & {
  modelType: 'income_shares' | 'melson';
  basePercentages: Record<'1' | '2' | '3' | '4', number>;
  obligorPercentages?: undefined;
};

type PercentageObligorConfig = SharedStateConfig & {
  modelType: 'percentage_obligor';
  obligorPercentages: Record<'1' | '2' | '3' | '4', number>;
  basePercentages?: undefined;
};

export type ChildSupportStateConfig = IncomeSharesConfig | PercentageObligorConfig;

export const CHILD_SUPPORT_STATES = statesJson as ChildSupportStateConfig[];
export const CHILD_SUPPORT_STATE_SLUGS = CHILD_SUPPORT_STATES.map((s) => s.slug);

export type ChildSupportStateSlug = (typeof CHILD_SUPPORT_STATE_SLUGS)[number];

export const CHILD_SUPPORT_STATE_BY_SLUG: Record<string, ChildSupportStateConfig> =
  CHILD_SUPPORT_STATES.reduce<Record<string, ChildSupportStateConfig>>((acc, state) => {
    acc[state.slug] = state;
    return acc;
  }, {});

export const CHILD_SUPPORT_STATE_BY_CODE: Record<string, ChildSupportStateConfig> =
  CHILD_SUPPORT_STATES.reduce<Record<string, ChildSupportStateConfig>>((acc, state) => {
    acc[state.code] = state;
    return acc;
  }, {});

export function isStateSlug(slug: string): slug is ChildSupportStateSlug {
  return CHILD_SUPPORT_STATE_SLUGS.includes(slug);
}

export function getStateConfigBySlug(slug: string): ChildSupportStateConfig | undefined {
  return CHILD_SUPPORT_STATE_BY_SLUG[slug];
}

export function getChildSupportPageTitle(state: ChildSupportStateConfig): string {
  return `${state.name} Child Support Calculator (2026 Estimate)`;
}

export function getChildSupportPageDescription(state: ChildSupportStateConfig): string {
  return `Free ${state.name} child support calculator for a quick monthly estimate. Compare income and parenting time — educational only, not legal advice.`;
}
